import React, { useState } from 'react'
import './SelectContactEmail.scoped.sass'
import contactsService from '@/app-domains/contacts/contacts.service'
import StandaloneMessageService from '@/app-domains/messages/draft/writing.service'
import { Button } from '@/components/Button/Button'
import { ReactComponent as LetterIcon } from '@/assets/icons/email-letter-icon.svg'
import modalService from '@/services/modal.service'

const SelectContactEmail = (props) => {
  const [selectedEmails, setSelectedEmails] = useState([])
  const { contact } = props

  function getField () {
    if (props.field === 'tos') {
      return 'tos'
    } else if (props.field === 'ccs') {
      return 'ccs'
    } else if (props.field === 'bccs') {
      return 'bccs'
    }
  }

  return (
    <div className='main-container'>
      <div className='top-header'>
        <img src={contact?.contactimageuri} />
        <div className='name-div'>
          {contactsService.buildContactFullname(contact) || '-'}
        </div>
      </div>
      <div className='select-text'>
        Select email(s) to send to:
      </div>
      <div className='emails-div'>
        {contact.emails.map((email) => {
          const [isMarked, setIsMarked] = useState(false)
          function isPrimaryFunction () {
            if (email === contact.emails[0]) {
              return (
                <span className='primary-text'>primary</span>
              )
            } else {
              return (
                <></>
              )
            }
          }
          return (
            <div className='email' key={email}>
              <div className='left-part-email'>
                <LetterIcon />
                {email}
                {isPrimaryFunction()}
              </div>
              <input type='checkbox' checked={isMarked}
              onClick={(e) => {
                e.stopPropagation()
                const isChecked = e.target.checked
                setIsMarked(isChecked)
                const emailArr = [email]
                let newEmailArr = []
                if (isChecked !== false) {
                  newEmailArr = selectedEmails.concat(emailArr)
                } else {
                  newEmailArr = selectedEmails.filter((selectedEmail) => selectedEmail !== email)
                }
                setSelectedEmails(newEmailArr)
              }} />
            </div>
          )
        }
        )}
      </div>
      <div className='buttons-div'>
        <div className='cancel-button'>
          <Button content='Cancel' type='secondary' click={() => { modalService.close() }}/>
        </div>
        <div className='select-button'>
          <Button content='Select' click={() => {
            modalService.close()
            selectedEmails.map((email) => StandaloneMessageService.addToAddress(email, getField()))
          }}/>
        </div>
      </div>
    </div>
  )
}

export default SelectContactEmail
